define('viewModels/privileged/qm/util/ServiceResponseValidator',['lib/knockout',
        'lib/lodash4',
        'util/errorCallbackFactory',
        'util/ServiceResponseValidator',

        // No references
        'extensions/knockout.validation.extender',
        'extensions/i18n/knockout.i18n'
], function (ko, _, errorCallbackFactory, ServiceResponseValidator) {
    'use strict';

    function buildInvalidEvaluatorMessage(response, value, messageParamProperty) {
        var invalidEvaluator = value;
            if (_.isArray(value)) {
                if (response.messageParams && response.messageParams[messageParamProperty]) {
                    invalidEvaluator = _.find(value, {id: response.messageParams[messageParamProperty]});
                }
            }

            var result = {};
            if (invalidEvaluator && invalidEvaluator.name) {
                result.message = ko.i18n.renderString('evaluation.evaluatorsCantScore', {
                    value: invalidEvaluator.name
                });
            } else {
                result.message = ko.i18n.renderString('evaluation.evaluatorCantScore');
            }
            return result;
    }

    return function() {
        return new ServiceResponseValidator({
            'quality.evaluation.evaluator.not.quality.evaluator': function (response, value) {
                return buildInvalidEvaluatorMessage(response, value, 'evaluatorId');
            },
            'quality.calibration.expert.evaluator.not.quality.evaluator': function (response, value) {
                return buildInvalidEvaluatorMessage(response, value, 'expertEvaluatorId');
            }
        });
    };
});

